import {ControlledSwitch} from '@hm/fundamental'
import {Controller, useForm} from 'react-hook-form'

import {useKilns} from '../providers'
import type {DepartmentNode} from '../types'

interface KilnSwitchProps {
  kilnNodes: DepartmentNode[]
}

export const KilnSwitch: React.FC<KilnSwitchProps> = ({kilnNodes}) => {
  const {selectedKiln, setSelectedKiln} = useKilns()

  const kilnOptions = kilnNodes.map((kiln, index) => ({
    label: `Kiln ${index + 1}`,
    value: kiln.upmId
  }))

  const handleOnKilnChange = (v: string | number) =>
    setSelectedKiln(kilnNodes.find((kilnNode) => kilnNode.upmId === v) as DepartmentNode)

  const {control} = useForm({
    defaultValues: {kilnSwitch: selectedKiln?.upmId ?? kilnOptions[0]?.value}
  })

  return (
    <Controller
      name="kilnSwitch"
      control={control}
      render={({field}) => (
        <ControlledSwitch
          name="kilnSwitch"
          options={kilnOptions}
          value={field.value}
          onChange={(value) => {
            field.onChange(value)
            handleOnKilnChange(value)
          }}
          data-cy="kiln_switch"
        />
      )}
    />
  )
}
